export default __webpack_public_path__ + "static/media/CompositesImg.d943156c.jpg";